import { observer } from 'mobx-react-lite';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import { DeliveryTimeWarning } from '~/components/HeaderV3/components/DeliveryTimeWarning/DeliveryTimeWarning';
import { UI_BOTTOM_COMPONENTS } from '~/constants/variables';
import { useBottomNavigation } from '~/hooks/useBottomNavigation';
import { useCheckoutButton } from '~/hooks/useCheckoutButton';
import { cartStore } from '~/stores';
import { formatPriceWithCurrency } from '~/utils/formaters';
import styles from './BottomNavigationBarV2.module.scss';
import { NavigationBarFabrique } from './components/NavigationBarFabrique';

const BottomNavigationCheckoutBarV2 = observer(() => {
  const navigate = useNavigate();
  useBottomNavigation();

  const {
    isDisabled: isDisabledCheckoutButton,
    onClick: onClickCheckoutButton,
    text: checkoutButtonText,
    description,
    isLoading: isLoadingCheckoutButton,
    isDisabledForm,
  } = useCheckoutButton();

  const [isVisibleNavBar] = useState(true);
  const cartButtonRef = useRef<HTMLElement>(null);

  return isVisibleNavBar ? (
    <div
      className={styles.container}
      data-company={company.name}
      id={UI_BOTTOM_COMPONENTS.NAVBAR}
    >
      <div className={styles.innerContainer}>
        <NavigationBarFabrique
          variant="withCTA"
          cta={{
            text: `${checkoutButtonText}`,
            subtitle:
              description ||
              formatPriceWithCurrency(cartStore.finalPrice) ||
              '',
            isActive: !description,
            disabled: isDisabledForm?.() || isDisabledCheckoutButton,
            onClick: onClickCheckoutButton,
            isLoading: isLoadingCheckoutButton,
          }}
          backButton={{ onClick: () => navigate('/cart') }}
        />
      </div>
      <DeliveryTimeWarning buttonRef={cartButtonRef} />
    </div>
  ) : null;
});

export default BottomNavigationCheckoutBarV2;
